"use client";

import { createContext, type RefObject } from "react";

import type { IconName } from "../theme";

/**
 * Represents a section that can be registered in the content menu
 */
export type ContentMenuSection = {
  id: string;
  index?: number;
  label: string;
  icon?: IconName;
  ref: RefObject<HTMLElement | null>;
  disable?: boolean;
  forcePosition?: "leading" | "leadingInside" | "trailing";
};

/**
 * State shape for the ContentMenu context
 */
export type ContentMenuContextState = {
  /**
   * Register a new section in the content menu
   */
  registerSection: (section: ContentMenuSection) => void;
  /**
   * Unregister a section from the content menu
   */
  unregisterSection: (id: string) => void;
  /**
   * List of all registered sections
   */
  sections: ContentMenuSection[];
};

/**
 * Context for the ContentMenu system
 */
export const ContentMenuContext = createContext<ContentMenuContextState | null>(
  null,
);
